export const inputBorderRadiusMedium = "0.75rem";
export const inputBorderRadiusSmall = "0.5rem";

export const shadowSmall = "0px 8px 8px 0px #2B2B2B0F";
export const shadowMedium = "0px 12px 24px 0px #2B2B2B14";
export const shadowLarge = "0px 12px 40px 0px #2B2B2B14";
